import dayjs from 'dayjs';
import { isDayBetween } from '@ha/date';

import {
  isDayAfter,
  isDayBefore,
  isDayExcluded,
  RangeModifier,
} from 'ha/ui/next/DatePicker';

import calcFirstAvailableToDate from './calcFirstAvailableToDate';

import { DateSelectionRules } from '../types';

const isToDateDisabled = (
  day: Date,
  from?: Date,
  exclusions: RangeModifier[] = [],
  minimumPeriod = 0,
  dateSelectionRules: DateSelectionRules = {},
) => {
  const { minDate, maxDate } = dateSelectionRules;

  if (minDate && isDayBefore(day, new Date(minDate))) {
    return true;
  }

  if (maxDate && isDayAfter(day, new Date(maxDate))) {
    return true;
  }

  if (isDayExcluded(day, exclusions)) {
    return true;
  }

  // current day overlaps one of exclusions' periods
  const hasOverlap = exclusions.some(
    (excl: RangeModifier) =>
      from && dayjs(day).isAfter(from) && isDayBetween(from, day, excl.from),
  );

  if (hasOverlap) {
    return true;
  }

  if (from && minimumPeriod) {
    const minimumAvailableDay = calcFirstAvailableToDate(from, minimumPeriod);

    if (isDayBefore(day, minimumAvailableDay)) {
      return true;
    }
  }

  return false;
};

export default isToDateDisabled;
